<template>
    <v-layout column wrap align-center justify-center>
        <div class="title primary--text mb-5">{{message}}</div>
        <div><v-btn @click="onFirstWatch()" color="primary background--text">{{$t("vod.btn.watch.now")}}</v-btn></div>
    </v-layout>
</template>
<script>
export default {
    name: "VodAvailabilityMessage",
    props: {
        message: {
            type: String,
            dafault: null
        },
        screener: {
            type: Object,
            default: null
        }
    },
    methods: {
        async onFirstWatch() {
        await this.$store
            .dispatch("screening/markFirstWatch", {
                screener_id: this.screener.id,
            })
            .then((response) => {
                this.$emit('firstWatchInitiated');
            })
            .catch((error) => {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error",
                });
            });
        },
    }
}
</script>
